'use strict';

function initTooltip() {
    $('.js-promo-progress-bar').each(function () {
        const $bar = $(this);

        if ($bar.find('.ppb-tooltip').length) {
            $bar.find('.ppb-tooltip').remove();
        }
        const $toolTip = $('<div class="ppb-tooltip" role="tooltip" style="display:none;"></div>').appendTo($bar);

        let lastTouchTs = 0;

        function getIndicator($from) {
            if ($from.hasClass('js-promo-progress-bar-tier-threshold-indicator-wrapper')) return $from;
            const $tier = $from.closest('.js-promo-progress-bar-tier');
            return $tier.find('.js-promo-progress-bar-tier-threshold-indicator-wrapper').first();
        }

        function getMsg($ind) {
            return ($ind.attr('data-tooltip') || '').trim();
        }

        // Center under indicator
        function setTooltipPositio($ind) {
            $toolTip.css({ display: 'block', visibility: 'hidden', left: 0 });
            const barWidth = $bar.outerWidth();
            const indOffset = $ind.position();
            const indWidth = $ind.outerWidth();
            const indHeight = $ind.outerHeight();
            const tipWidth = $toolTip.outerWidth();

            const centerX = indOffset.left + (indWidth / 2);
            const desiredLeft = centerX - (tipWidth / 2);
            const minLeft = 0;
            const maxLeft = barWidth - tipWidth;
            const clampedLeft = Math.max(minLeft, Math.min(desiredLeft, maxLeft));

            const top = indOffset.top + indHeight + 2;

            $toolTip.css({
                left: clampedLeft,
                top,
                visibility: ''
            });
        }

        function showFor($from) {
            const $ind = getIndicator($from);
            if (!$ind.length) return;

            const msg = getMsg($ind);
            if (!msg) return;
            // Stop any running animations before starting a new one
            $toolTip.stop(true, true);

            $toolTip.text(msg);
            setTooltipPositio($ind);

            // Fade in only if not already visible
            if (!$toolTip.is(':visible')) {
                $toolTip.fadeIn(200);
            }
        }

        function hideTip() {
            // Stop any running animations before hiding
            $toolTip.stop(true, true).fadeOut(200);
        }

        $bar.off('mouseenter', '.js-promo-progress-bar-tier')
            .on('mouseenter', '.js-promo-progress-bar-tier', function () {
                showFor($(this));
            });

        $bar.off('mouseleave', '.js-promo-progress-bar-tier')
            .on('mouseleave', '.js-promo-progress-bar-tier', function (e) {
                // If moving into the tooltip, keep it open
                const to = e.relatedTarget;
                if (to && $toolTip[0].contains(to)) return;
                hideTip();
            });

        $toolTip.off('mouseleave')
            .on('mouseleave', function (e) {
                // Hide only if the mouse is leaving the tooltip AND not going to anything inside the bar
                const to = e.relatedTarget;
                const goingIntoBar = !!(to && $bar[0].contains(to));
                if (!goingIntoBar) hideTip();
            });

        $bar.off('focusin focusout', '.js-promo-progress-bar-tier, .js-promo-progress-bar-tier *')
            .on('focusin', '.js-promo-progress-bar-tier, .js-promo-progress-bar-tier *', function () {
                const $tier = $(this).closest('.js-promo-progress-bar-tier');
                showFor($tier);
            });

        $bar.off('focusout', '.js-promo-progress-bar-tier, .js-promo-progress-bar-tier *')
            .on('focusout', '.js-promo-progress-bar-tier, .js-promo-progress-bar-tier *', function () {
                setTimeout(() => {
                    const active = document.activeElement;
                    const stillInside = $bar[0].contains(active) || $toolTip[0].contains(active);
                    if (!stillInside) hideTip();
                }, 0);
            });

        $(document).off('keydown.ppb').on('keydown.ppb', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') hideTip();
        });

        $bar.off('touchstart', '.js-promo-progress-bar-tier')
            .on('touchstart', '.js-promo-progress-bar-tier', function () {
                lastTouchTs = Date.now();
                showFor($(this));
            });

        if (window.tooltipTouchstartOutsideInitialized !== true) {
            window.tooltipTouchstartOutsideInitialized = true;
            $(document).on('touchstart click', function (e) {
                // ignore ghost click right after touch
                if (e.type === 'click' && (Date.now() - lastTouchTs) < 350) return;
                const inside = $bar[0].contains(e.target) || $toolTip[0].contains(e.target);
                if (!inside) hideTip();
            });
        }

        // Reposition if layout shifts
        const onRelayout = function () {
            if (!$toolTip.is(':visible')) return;
            const $hoverInd = $bar.find('.js-promo-progress-bar-tier:hover .js-promo-progress-bar-tier-threshold-indicator-wrapper').first();
            if ($hoverInd.length) setTooltipPositio($hoverInd);
        };
        if (window.tooltipOnRelayoutInitialized !== true) {
            window.tooltipOnRelayoutInitialized = true;
            $(window).on('resize scroll', onRelayout);
        }
    });
}

module.exports = {
    update: function ($newProgressBarHtml, $currentProgressBarHtml, announceDelay) {
        if ($newProgressBarHtml && $newProgressBarHtml.length > 0 && $currentProgressBarHtml && $currentProgressBarHtml.length > 0) {
            var newPromoProgressBarData = $newProgressBarHtml.find('.promo-progress-bar').data('promo-progress-bar-data');

            if (newPromoProgressBarData && newPromoProgressBarData.discounts && newPromoProgressBarData.discounts.length > 0) {
                $currentProgressBarHtml.removeClass('d-none');

                var promoBarDiscounts = newPromoProgressBarData.discounts;
                var newDiscountInProgress = newPromoProgressBarData.discountInProgress;
                var newPreviousDiscount = newPromoProgressBarData.previousDiscount;
                var newDiscountInProgressTier = newPromoProgressBarData.discountInProgressTier;
                var newHighestDiscountThreshold = newPromoProgressBarData.highestDiscountThreshold;
                var newHighestAppliedTierDiscount = newPromoProgressBarData.highestAppliedTierDiscount;

                var newProgress = newDiscountInProgress ? newDiscountInProgress.merchandiseTotal : newHighestDiscountThreshold;
                var newDiscountThreshold = newDiscountInProgress ? newDiscountInProgress.discountThreshold : newHighestDiscountThreshold;
                var newPreviousDiscountThreshold = newPreviousDiscount ? newPreviousDiscount.discountThreshold : 0;

                var newCurrentTierProgressPercentage = (((newProgress - newPreviousDiscountThreshold) * 100) / (newDiscountThreshold - newPreviousDiscountThreshold)) / promoBarDiscounts.length;
                var newCompletedTierProgressPercentage = ((newDiscountInProgressTier - 1) * 100) / promoBarDiscounts.length;
                var newProgressPercentage = newCurrentTierProgressPercentage + newCompletedTierProgressPercentage;

                // progress = set new bar width to current bar width to animate later
                var currentProgressBarFillCSSWidth = $currentProgressBarHtml.find('.progress-bar-fill').css('width');
                var currentProgressBarCSSWidth = $currentProgressBarHtml.find('.progress-bar').css('width');
                var currentProgressBarFillWidth = currentProgressBarFillCSSWidth ? parseInt(currentProgressBarFillCSSWidth, 10) : 0;
                var currentProgressBarWidth = currentProgressBarCSSWidth ? parseInt(currentProgressBarCSSWidth, 10) : 100;
                var currentProgressPercentage = (currentProgressBarFillWidth * 100) / currentProgressBarWidth;

                // thresholds - keep applied if indicator is behind current progress percent and animate later
                var $newProgressBarTiersContainer = $newProgressBarHtml.find('.promo-progress-bar-tiers');
                var $newProgressBarTiers = $newProgressBarTiersContainer.find('.promo-progress-bar-tier');
                var newProgressBarTierCount = $newProgressBarTiers.length;
                $newProgressBarTiers.each(function (index) {
                    var promoProgressBarTier = index + 1;
                    var tierThresholdPercentage = (promoProgressBarTier * 100) / newProgressBarTierCount;
                    if (tierThresholdPercentage <= currentProgressPercentage) {
                        $(this).addClass('applied');
                    } else {
                        $(this).removeClass('applied');
                    }
                });

                // label - inject current label to fade out and fade in new label later
                $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container.atc-promo-bar-label-placeholder').remove();
                var $currentLabelContainer = $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container');
                var $newLabelContainer = $newProgressBarHtml.find('.promo-progress-bar-threshold-message-container');
                if ($currentLabelContainer.length > 0 && $newLabelContainer.length > 0) {
                    $currentLabelContainer.addClass('to-be-removed');
                    $currentLabelContainer.find('.promo-progress-bar-threshold-message').removeAttr('id');
                    $newLabelContainer.css('opacity', 0).addClass('to-be-shown');

                    // show qualified label if highest promotion was not applied previously
                    if (newHighestAppliedTierDiscount) {
                        var justQualified = true;
                        $currentProgressBarHtml.find('.promo-progress-bar-tier.applied').each(function () {
                            if ($(this).data('promotion-id') === newHighestAppliedTierDiscount.promoID) justQualified = false;
                        });
                        if (justQualified) {
                            $newLabelContainer.find('.promo-progress-bar-threshold-message').each(function () {
                                if ($(this).data('promotion-id') === newHighestAppliedTierDiscount.promoID) {
                                    $(this).removeClass('d-none');
                                } else {
                                    $(this).addClass('d-none');
                                }
                            });
                        }
                    }

                    if (newProgressPercentage > currentProgressPercentage) {
                        $currentLabelContainer.addClass('delay-transition');
                        $newLabelContainer.addClass('delay-transition');
                    }
                }

                // update data
                $currentProgressBarHtml.find('.promo-progress-bar').data('promo-progress-bar-data', newPromoProgressBarData);

                // inject label
                if ($currentLabelContainer.length > 0 && $newLabelContainer.length > 0) {
                    $currentLabelContainer.after($newLabelContainer);
                    $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container.to-be-removed').css('position', 'absolute').css('top', '0');
                }

                // replace tiers
                $currentProgressBarHtml.find('.promo-progress-bar-tiers').replaceWith($newProgressBarTiersContainer);

                // update progress
                $currentProgressBarHtml.find('.progress-bar-fill').width(newProgressPercentage + '%');

                // update indicators
                promoBarDiscounts.forEach(promoBarDiscount => {
                    if (promoBarDiscount.applied) {
                        $currentProgressBarHtml.find('.promo-progress-bar-tier:not(.applied)[data-promotion-id="' + promoBarDiscount.promoID + '"]').addClass('applied');
                    } else {
                        $currentProgressBarHtml.find('.promo-progress-bar-tier.applied[data-promotion-id="' + promoBarDiscount.promoID + '"]').removeClass('applied');
                    }
                });

                // update label
                var $labelContainerToRemove = $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container.to-be-removed');
                $labelContainerToRemove.on('transitionend', function () {
                    $labelContainerToRemove.remove();
                });
                var $labelContainerToShow = $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container.to-be-shown');
                var $displayedLabel = $labelContainerToShow.find('.promo-progress-bar-threshold-message:not(.d-none)');
                var promoProgressBarAnnouncerText = $displayedLabel.length > 0 ? $displayedLabel.get(0).innerText : '';

                $labelContainerToShow.on('transitionend', function () {
                    $labelContainerToShow.removeClass('delay-transition');
                });
                $labelContainerToRemove.css('opacity', 0);
                $labelContainerToShow.removeClass('to-be-shown').css('opacity', 1);

                // update aria-live with optional delay
                var delay = typeof announceDelay === 'number' ? announceDelay : 0;
                var $announcer = $('#promo-progress-bar-announcer');

                if (delay > 0) {
                    // Clear the announcer first to prevent immediate announcement
                    $announcer.text('');
                    setTimeout(function () {
                        $announcer.text(promoProgressBarAnnouncerText);
                    }, delay);
                } else {
                    $announcer.text(promoProgressBarAnnouncerText);
                }

                initTooltip();
            } else {
                $currentProgressBarHtml.addClass('d-none');
            }
        }
    },

    handle: function (promoProgressBar, announceDelay) {
        if (promoProgressBar && promoProgressBar.html) {
            var $newProgressBarHtml = $(promoProgressBar.html);
            var $currentProgressBarHtml = $('.promo-progress-bar-container');
            this.update($newProgressBarHtml, $currentProgressBarHtml, announceDelay);
        }
    },

    initATCProgressBar: function ($newProgressBarHtml, $currentProgressBarHtml) {
        if ($newProgressBarHtml && $newProgressBarHtml.length > 0 && $currentProgressBarHtml && $currentProgressBarHtml.length > 0) {
            var newPromoProgressBarData = $newProgressBarHtml.find('.promo-progress-bar').data('promo-progress-bar-data');

            $currentProgressBarHtml.toggleClass('d-none', $newProgressBarHtml.hasClass('d-none'));

            var currentProgressBarFillCSSWidth = $currentProgressBarHtml.find('.progress-bar-fill').css('width');
            var currentProgressBarFillWidth = currentProgressBarFillCSSWidth ? parseInt(currentProgressBarFillCSSWidth, 10) : 0;

            if (currentProgressBarFillWidth === 0) {
                $currentProgressBarHtml.find('.promo-progress-bar-tiers').replaceWith($newProgressBarHtml.find('.promo-progress-bar-tiers').clone());
                $currentProgressBarHtml.find('.promo-progress-bar-tier').removeClass('applied');

                if (newPromoProgressBarData && newPromoProgressBarData.discounts && newPromoProgressBarData.discounts.length > 0) {
                    var noProgressLabel = newPromoProgressBarData.discounts[0].noProgressLabel;
                    $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container')
                        .empty().append('<p class="promo-progress-bar-threshold-message">' + noProgressLabel + '</p>');
                }
            }

            initTooltip();
            // add in new but with zero opacity so screen reader reads new label
            // but still fade in new message and fade out old message
            var $newLabelContainer = $newProgressBarHtml.find('.promo-progress-bar-threshold-message-container').clone();
            var $currentLabelContainer = $currentProgressBarHtml.find('.promo-progress-bar-threshold-message-container');
            $newLabelContainer.addClass('atc-promo-bar-label-placeholder').css('opacity', 0).css('position', 'absolute').css('top', '0');
            $currentLabelContainer.attr('aria-hidden', 'true');

            var newHighestAppliedTierDiscount = newPromoProgressBarData ? newPromoProgressBarData.highestAppliedTierDiscount : null;
            // show qualified label if highest promotion was not applied previously
            if (newHighestAppliedTierDiscount) {
                var justQualified = true;
                $currentProgressBarHtml.find('.promo-progress-bar-tier.applied').each(function () {
                    if ($(this).data('promotion-id') === newHighestAppliedTierDiscount.promoID) justQualified = false;
                });
                if (justQualified) {
                    $newLabelContainer.find('.promo-progress-bar-threshold-message').each(function () {
                        if ($(this).data('promotion-id') === newHighestAppliedTierDiscount.promoID) {
                            $(this).removeClass('d-none');
                        } else {
                            $(this).addClass('d-none');
                        }
                    });
                }
            }
            $currentLabelContainer.before($newLabelContainer);
        }
    },
    initTooltip: initTooltip
};
